import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sentinel", "title"];

  // Watches the title sentinel and activates the title below the site header.
  // Stimulus calls this when a project show page enters the document.
  connect() {
    const headerHeight = this.siteHeaderHeight();

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.titleTarget.classList.toggle("project-show-header-stuck", !entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
      },
    );

    if (this.hasSentinelTarget && this.hasTitleTarget) {
      this.observer.observe(this.sentinelTarget);
    }
  }

  // Stops observing when Turbo removes the project show page.
  // Stimulus calls this before the controller disconnects.
  disconnect() {
    this.observer?.disconnect();
  }

  // Returns the rendered fixed-header height for the observer's pixel-based API.
  // Called during connection so CSS remains the source of truth for header height.
  siteHeaderHeight() {
    const siteHeader = document.querySelector("header.site-header");

    return siteHeader?.getBoundingClientRect().height || 0;
  }
}
